import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const countAllItems = 0;

const PublisherLandings = {
    getLandings(params, callback) {
        dispatch({
            type: AppConstants.LANDINGS_SEARCH_START_LOADING
        });

        return api.searchLandings(params)
        .then(data => {
            dispatch({
                type  : AppConstants.LANDINGS_SEARCH_SUCCESS,
                items : data.response || {}
            });

            callback && callback();
        })
        .catch(err => {
            handleError(err, () => {
                dispatch({
                    type: AppConstants.LANDINGS_FAIL,
                    error: err
                });
            });
        });
    },

    saveLanding(params) {
        return api.saveLanding(params);
    },

    getOfferLinks(params) {
        params.count = countAllItems;
        return api.getOfferLinks(params).then(data => {
            return Array.isArray(data.response) ? data.response : [];
        }).catch(err => {
            handleError(err, () => {
                dispatch({
                    type: AppConstants.LANDINGS_FAIL,
                    error: err
                });
            });
            return [];
        });
    }
};

export default PublisherLandings;
